export default __webpack_public_path__ + "static/media/DiceTraySize.1aabefbc.mp4";